import VueMultiselect from 'vue-multiselect';

export default {
	name: "year-filter",
	components: {
		VueMultiselect
	},
	props: {
		defaultYear: {
			type: Number,
			required: false,
		},
	},
	data() {
		return {
			selectedYear: undefined,
			isOpened: false,
		};
	},
	computed: {
		yearList() {
			const yearList = [];
			const thisYear = new Date().getFullYear();
			for (let i = thisYear; i >= 2004; i--) {
				yearList.push(i);
			}
			return yearList;
		},
		lang() {
			return window.lang || 'hu';
		}
	},
	methods: {
		changeYear(year) {
			this.selectedYear = year;
			this.isOpened = false;
			this.$emit('on-year-change', year);
		},
		getActiveYear(year) {
			return this.selectedYear == year;
		},
		allYear() {
			this.selectedYear = undefined;
			this.isOpened = false;
			this.$emit('on-year-change', this.selectedYear);
		}
	},
	created() {
		if (this.defaultYear) {
			this.selectedYear = this.defaultYear;
		 }
	}
}



// WEBPACK FOOTER //
// ../source/common/year-filter/year-filter.js